import {
  UseInfiniteQueryResult,
  useInfiniteQuery
} from "@tanstack/react-query";
import { useContext } from "react";

import { API_URL_CASES } from "constants/api_urls";
import { AxiosContext } from "contexts/AxiosContext";
import { makeQueryString } from "core/makeQueryString";
import { CaseStreamResponse } from "interfaces/case-stream";
import { dataOrAll } from "hooks/queries/utils/dataOrAll";

export const useStreamFeedQuery = (
  caseId: number,
  filterTypes?: string[],
  pageSize: number = 10,
  initialPage: number = 1,
  ordering: string = "-datetime"
): UseInfiniteQueryResult<CaseStreamResponse, unknown> => {
  const { axios } = useContext(AxiosContext)!;

  return useInfiniteQuery<CaseStreamResponse, unknown>({
    queryKey: ["streamFeed", caseId, dataOrAll(filterTypes)],
    getNextPageParam: lastPage => {
      // Extract the page number from the url provided in the "next" parameter
      const matches = lastPage.next?.match(/page=[0-9]+/) ?? undefined;
      if (matches !== undefined && matches.length > 0) {
        const [, pageNumber] = matches[0].split("=");
        return pageNumber;
      }

      // Undefined tells react query there is no next page
      return undefined;
    },
    queryFn: ({ pageParam = initialPage }) =>
      axios
        .get<CaseStreamResponse>(
          `${API_URL_CASES}/${caseId}/stream${makeQueryString(
            {
              page: pageParam,
              size: pageSize,
              ordering: ordering,
              filter_type: filterTypes
            },
            true
          )}`
        )
        .then(r => r.data),
    refetchOnWindowFocus: false
  });
};
